import { Utils } from '@genial/utils';
import { useState } from 'react';

import {
  AssetDefaultOrSelectedTypeMap,
  SubmitUpdateProps,
} from '../../../../../../../store/product/types';

export const useDirectTreasurySellAssetController = (
  offer: AssetDefaultOrSelectedTypeMap['directTreasurySell'],
  submitUpdate?: (data: SubmitUpdateProps) => Promise<boolean>
) => {
  const defaultQuantity =
    offer.orderQuantity || offer.availableQuantity || offer.minimumStepQuantity;

  const [amountItem, setAmountItem] = useState(defaultQuantity);

  const handleChangeAmountItem = async (value: number) => {
    const multiple = Number((offer.sellValue || 0).toFixed(2));
    const multipliedValue = value * parseFloat(multiple.toFixed(2));
    const priceItem = parseFloat(multipliedValue.toFixed(2));

    const updateFormValues = () => {
      setAmountItem(value);
    };

    if (submitUpdate) {
      const response = await submitUpdate({ amount: priceItem, price: value });
      if (response) {
        updateFormValues();
      }
    } else {
      updateFormValues();
    }
  };

  const calcGrossSellValue = (currentQuantity: number) => {
    return Number((offer.sellValue * currentQuantity).toFixed(2));
  };

  const amountValue = calcGrossSellValue(amountItem);

  return {
    amountItem,
    amountValue,
    amountValueFormatted: Utils.Mask.Money(amountValue),
    handleChangeAmountItem,
  };
};

export type DirectTreasurySellController = ReturnType<typeof useDirectTreasurySellAssetController>;
